export default __webpack_public_path__ + "static/reduce-complexity-47a877c42307ef84d7bf423fdcad5e12.svg";